import * as React from 'react'
import { InventoryService } from './inventoryService'

export const InventoryServiceContext = React.createContext(null as any as InventoryService)
